import type * as React from "react";
import { Toaster as SonnerToaster, type ToasterProps } from "sonner";
import { cn } from "../lib/cn";

/**
 * Toast — Sonner-backed toaster.
 *
 * shadcn deprecated the Radix-toast in favour of Sonner (commit Aug 2024)
 * for v2.0 — same `toast()` API, far less ceremony, motion-tokens built in.
 * Mount `<Toaster />` once at the root of each app. Use `useToast()` from
 * `@ando/ui/hooks` to dispatch messages.
 */
const Toaster: React.FC<ToasterProps> = ({ className, ...props }) => (
  <SonnerToaster
    theme="light"
    className={cn("toaster group", className)}
    toastOptions={{
      classNames: {
        toast:
          "group toast group-[.toaster]:bg-card group-[.toaster]:text-ink-1 group-[.toaster]:border group-[.toaster]:border-hairline group-[.toaster]:shadow-md group-[.toaster]:rounded-md",
        description: "group-[.toast]:text-ink-2",
        actionButton:
          "group-[.toast]:bg-accent group-[.toast]:text-accent-foreground",
        cancelButton:
          "group-[.toast]:bg-cream-deep group-[.toast]:text-ink-2",
      },
    }}
    {...props}
  />
);
Toaster.displayName = "Toaster";

export { Toaster };
export { toast } from "sonner";
